var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThailand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5875 15.9999H0.4125C0.182813 15.9999 0 15.809 0 15.5801V0.419792C0 0.186046 0.1875 0 0.4125 0H23.5828C23.8125 0 23.9953 0.190813 23.9953 0.419792V15.5801C24 15.8138 23.8125 15.9999 23.5875 15.9999Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5875 16.0001H0.4125C0.182813 16.0001 0 15.8093 0 15.5803V13.4766H24V15.5803C24 15.814 23.8125 16.0001 23.5875 16.0001Z",
    fill: "#EE1B24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.4125 0.000244141H23.5828C23.8125 0.000244141 23.9953 0.191062 23.9953 0.420041V2.52378H0V0.420041C0 0.186289 0.1875 0.000244141 0.4125 0.000244141Z",
    fill: "#EE1B24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.05176H0V10.948H24V5.05176Z",
    fill: "#241D52"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThailand);
export default __webpack_public_path__ + "static/media/Thailand.c86b0a7788623b96c7355ddb1b790a16.svg";
export { ForwardRef as ReactComponent };